// @flow
import React, { useContext, Fragment } from 'react';
import Head from 'next/head';

import { useRouter } from 'Client/router/useRouter';
import canonicalService from 'Src/seo/canonical';
import { ReactPageContext } from 'Context/pageContext';
import { convertLocationToURI } from 'Utils/uri/uriUtils';

export const HeadInfos = () => {
  const pageContext = useContext(ReactPageContext);
  // It should be ProductQueryParams, it's in another PR not merged yet
  const { location } = useRouter<*, GlobalQueryParams>();

  return (
    <Fragment>
      <Head>
        <meta name="description" content={pageContext.pageDescription || ''} />
        <link
          rel="canonical"
          href={canonicalService.getCanonicalUrl(convertLocationToURI(location).toString())}
        />
        {(pageContext.hrefLang || [])
          .filter(hrefLang => hrefLang.url && hrefLang.locale)
          .map(({ locale, url }) => (
            <link key={`${locale}_${url}`} rel="alternate" hrefLang={locale} href={url} />
          ))}
      </Head>
    </Fragment>
  );
};
